<template>
    <div>
        {{ $t('notification.taskWorkflowUpdated', { 
            actor: $_.get(activity, 'actorUser.name'), 
            workflowTitle: $_.get(activity, 'payload.workflowTitle')
        }) }}
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskWorkflowUpdated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

